import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { StorySlide as ContinueReadingSlide } from "@wattpad/web-ui-library";

import {
  formatStoryDataforStorySlides,
  sizeStoryCover,
  slideSubLabel
} from "./ContinueReadingSwimlaneUtils";
import SectionHeader from "../../components/SectionHeader";
import { useTrans } from "../../../../hooks";
import { Icon } from "../../../../shared-components";
import { toPostedDate } from "../../../comments/CommentsUtils";

const ContinueReadingSwimlane = ({
  heading,
  subheading,
  items,
  windowWidth,
  index
}) => {
  const { trans, ngettext } = useTrans();
  let backBtnRef = useRef();

  const [slidesIndex, setSlidesIndex] = useState(0);
  const [showNextButton, setShowNextButton] = useState(true);
  const [showBackButton, setShowBackButton] = useState(false);
  let slides = formatStoryDataforStorySlides(items, ngettext);

  useEffect(
    () => {
      if (slidesIndex + 5 >= slides.length) {
        setShowNextButton(false);
      }
    },
    [slidesIndex, slides]
  );

  useEffect(
    () => {
      if (showBackButton) {
        backBtnRef.current?.focus();
      }
    },
    [showBackButton]
  );

  const storyOnClick = (storyData, storyIndex) => {
    window.te.push("event", "story", null, null, "click", {
      storyid: storyData.id,
      page: "home",
      algo_source: ["storiesRecommendedRNN"],
      position: index,
      offset: storyIndex,
      type: "yourStories"
    });
  };

  return (
    <div className="continue-reading story-swimlane module">
      <div className="module-content full-width">
        <SectionHeader heading={heading} subheading={subheading} />
        {/* then we can pass slides to story carousel to render the new ds component like this */}

        <div className="carousel-container">
          <div
            className={classNames("back-btn-container", {
              "first-slide": !showBackButton
            })}
          >
            {showBackButton && (
              <button
                ref={backBtnRef}
                className="back-btn"
                onClick={() => {
                  setSlidesIndex(slidesIndex - 5);
                  setShowNextButton(true);
                  if (slidesIndex - 5 === 0) {
                    setShowBackButton(false);
                  }
                }}
                aria-label={trans("Back")}
              >
                {showBackButton && (
                  <Icon
                    name="arrowCircleLeft"
                    size="40"
                    alt="back"
                    strokeWidth="2.25"
                  />
                )}
              </button>
            )}
          </div>

          <div className="continue-reading-carousel">
            {slides
              .slice(
                slidesIndex,
                slidesIndex + 5 > slides.length
                  ? slides.length
                  : slidesIndex + 5
              )
              .map((storyData, i) => {
                if (storyData.id && storyData.cover)
                  return (
                    <ContinueReadingSlide
                      key={`${storyData.id}-${i}`}
                      id={storyData.id}
                      storyName={storyData.title}
                      primaryLabel={storyData.primary_label}
                      secondaryLabel={storyData.secondary_label}
                      cover={sizeStoryCover(
                        windowWidth,
                        storyData.type,
                        storyData.cover
                      )}
                      totalParts={storyData.total_parts}
                      current_part_index={storyData.current_part.number}
                      current_part_id={storyData.current_part.id}
                      newParts={storyData.new_parts}
                      progressBarAccessibility={
                        storyData.progressBarAccessibility
                      }
                      lastPubDate={toPostedDate(
                        trans,
                        ngettext,
                        storyData.last_pub_date
                      )}
                      leadingDivider={storyData.leading_divider}
                      subLabel={slideSubLabel(storyData, ngettext)}
                      topMargin={storyData.type !== "currentRead"}
                      onClick={storyOnClick(storyData, i)}
                    />
                  );
              })}
          </div>

          <div className="next-btn-container">
            {showNextButton && (
              <button
                className="next-btn"
                onClick={() => {
                  setShowBackButton(true);
                  if (slidesIndex + 5 <= slides.length) {
                    setSlidesIndex(slidesIndex + 5);
                  } else {
                    setShowNextButton(false);
                  }
                  backBtnRef.current?.focus();
                }}
                aria-label={trans("Next")}
              >
                <Icon
                  name="arrowCircleRight"
                  size="40"
                  alt="next"
                  strokeWidth="2.25"
                />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContinueReadingSwimlane;

ContinueReadingSwimlane.propTypes = {
  heading: PropTypes.string,
  subheading: PropTypes.string,
  items: PropTypes.array,
  windowWidth: PropTypes.number,
  index: PropTypes.number
};
